import * as Constants from '@kta20-core/constants';
import {IAppContext} from '@kta20-core/interfaces/i-app-context';

/**
 * Interface implemented by all
 * modules and used to configure
 * each module during app boot time.
 */
export interface IModuleConfig {
    name: string;
}

/**
 * Starting class to create new modules
 * bringing new features to the app.
 * A module must own a business specific
 * logic of the app. 
 * 
 * Use the "config" param in "factory()" method
 * to provide app-wide services/managers to
 * the module. Never import concrete services/managers
 * in the module it-self. 
 */
export abstract class BaseModule {

    /**
     * Config of th module set during
     * module init from ModuleLoader
     *
     * @see @kta20-core/module-loader.ts
     */
    protected static config:IModuleConfig;

    protected static appContext:IAppContext;

    /**
     * Returns the configuration of the module
     * provided during initialization.
     * Normally you access this from module's
     * components (view-models, views, etc)
     */
    public static getConfig():IModuleConfig{
        return this.config;
    }

    public static getAppContext():IAppContext{
        return this.appContext;
    }

    /**
     * Creates an instance of the module.
    * Use the "appContext" param
    * to provide app-wide services/managers to
    * the module. Never import concrete services/managers
    * in the module it-self. 
     * @param appContext : Object owning app config and app-wide dependencies.
     * @param moduleConfig : Object owning module config.
     */
    static async factory(appContext: IAppContext, moduleConfig?: IModuleConfig): Promise<BaseModule> {
        appContext; moduleConfig;
        throw new Error(Constants.METHOD_NOT_IMPL);
    };

}